@use '../@shared/global' as *;
@use '../host-display-block' as *;
@use '../@shared/collapsible.mixin' as *;
@use '../@shared/icon.mixin' as *;

@layer kol-component {
	@include kol-icon-styles();
}
